import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, NgModule, OnInit } from '@angular/core';
import { Cms } from '@impact/data';
import { ButtonModule } from '../../button/button.module';
import { RichTextModule } from '../../rich-text/rich-text.module';
import { SidePanelService } from '../../side-panel/side-panel.service';
import { UtilsModule } from '../../utils/utils.module';

@Component({
    selector: 'app-quote-from-expert-spot',
    template: `
        <section class="layout-wrapper">
            <div class="quote-from-expert-spot">
                <app-rich-text class="quote-from-expert-spot__quote" [html]="data.headlineAndQuote"></app-rich-text>
                <img
                    *ngIf="data.image as image"
                    class="quote-from-expert-spot__expert-image"
                    [attr.src]="image?.src | resolveMediaUrl: { format: 'webp', width: 80 } "
                    [attr.alt]="image?.alt"
                    width="80"
                    height="80"
                    loading="lazy"
                    appImageLoadFadeIn
                />
                <div class="quote-from-expert-spot__expert-name">
                    {{ data.expertName }}
                </div>
                <div class="quote-from-expert-spot__expert-title">
                    {{ data.expertTitle }}
                </div>
                <app-button
                    *ngIf="data.cta"
                    [title]="data.cta"
                    buttonClass="button--primary button--themed"
                    (click)="showAskTheExpertPanel()"
                ></app-button>
            </div>
        </section>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
class QuoteFromExpertSpotComponent {
    static ref = 'quotefromexpertspot';

    @Input() data: Cms.QuoteFromExpertSpot;

    constructor(private sidePanelService: SidePanelService) {}

    showAskTheExpertPanel() {
        this.sidePanelService.showAskTheExpert();
    }
}

@NgModule({
    declarations: [QuoteFromExpertSpotComponent],
    imports: [CommonModule, RichTextModule, ButtonModule, UtilsModule],
})
class QuoteFromExpertSpotModule {}

export const LazySpotComponent = QuoteFromExpertSpotComponent;
